import Enums from "@/plugin/Enums";
const PostTypes = Enums.get().PostTypes
class PostData {
    constructor(operationType, dictionary, name) {
        this.operationType = operationType
        this[name] = dictionary
    }

    get operationTypeValue() {
        return this.operationType
    }
    get dictionaryValue() {
        return this.dictionary
    }
}

class PostDataTools{
    /**
     * 获取
     * @param operationType
     * @param dictionary
     * @param name
     * @returns {PostData}
     * @private
     */
    option(operationType, dictionary, name){
        return new PostData(operationType, dictionary, name)
    }

    /**
     * 新增（保存草稿）
     * @param dictionary
     */
    create(dictionary, name){
        return this.option(PostTypes.Create, dictionary, name)
    }
    /**
     * 更新
     * @param dictionary
     */
    update(dictionary, name){
        return this.option(PostTypes.Update, dictionary, name)
    }
    /**
     * 保存并提交
     * @param dictionary
     */
    saveAndSubmit(dictionary, name){
        return this.option(PostTypes.SaveAndSubmit, dictionary, name)
    }
    /**
     * 提交
     * @param dictionary
     */
    submit(dictionary, name){
        return this.option(PostTypes.Submit, dictionary, name)
    }
    /**
     * 审核
     * @param dictionary
     */
    audit(dictionary, name){
        return this.option(PostTypes.Audit, dictionary, name)
    }
    /**
     * 驳回
     * @param dictionary
     */
    reject(dictionary, name){
        return this.option(PostTypes.Reject, dictionary, name)
    }
    /**
     * 作废
     * @param dictionary
     */
    cancel(dictionary, name){
        return this.option(PostTypes.Cancel, dictionary, name)
    }
    /**
     * 删除
     * @param dictionary
     */
    delete(dictionary, name){
        return this.option(PostTypes.Delete, dictionary, name)
    }
    /**
     * 完成（整改通知）
     * @param dictionary
     */
    finish(dictionary, name){
        return this.option(PostTypes.Finish, dictionary, name)
    }

}

export default PostDataTools
